import PropTypes from "prop-types"

import { IconButton } from "@mui/material"
import { MoreVert } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function MenuButton({ openMenu }) {
  return <div className="menu">
    <Tooltip title="More actions">
      <IconButton className="resource-menu-icon" onClick={openMenu} size="large">
        <MoreVert />
      </IconButton>
    </Tooltip>
  </div>
}

MenuButton.propTypes = {
  openMenu: PropTypes.func.isRequired,
}
